export const calculatorAPI = {
    async calculate(data) {
        const resp = await fetch("/api/calculator/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }).catch((err) => console.log(err));

        let error = null;
        let body = await resp
            .json()
            .catch((e) => (error = "something_went_wrong"));

        if (error) {
            return {
                ok: false,
                err: error,
            };
        }

        if (!body) {
            return {
                ok: false,
                error: "something_went_wrong",
            };
        }

        if (body.ok) {
            return {
                ok: true,
                result: {
                    prices: body.prices,
                    usedVolumeWeight: body["used-volume-weight"],
                },
            };
        }

        if (body.err) {
            switch (body.err) {
                case "no prices found":
                    return {
                        ok: false,
                        err: "calculator_no_prices_found",
                    };
                default:
                    return {
                        ok: false,
                        err: "something_went_wrong",
                    };
            }
        }

        if (body.validationErrors) {
            return {
                ok: false,
                err: "invalid_data",
            };
        }

        return {
            ok: false,
            error: "something_went_wrong",
        };
    },
};
